// EmpatheticCaregiversSection.js
import React from 'react';
import { ArrowRight } from 'lucide-react';
import empatheticCaregiversImage from '../assets/empathetic-caregivers-image.jpg';

const tasks = [
  'Bathing, showering, and bed baths',
  'Laundry and light housekeeping',
  'Toilet and incontinence care',
  'Grooming and oral hygiene',
];

const EmpatheticCaregiversSection = () => {
  return (
    <section className="bg-white overflow-hidden">
      {/* Calm cream intro band */}
      <div className="bg-cream">
        <div className="max-w-4xl mx-auto px-6 text-center py-20 md:py-28">
          <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-6">
            Wei Care Home Care
          </p>
          <h2 className="font-display font-light text-ink leading-snug text-3xl md:text-4xl lg:text-[2.9rem] mb-6">
            Proudly Caring for Queensland's Seniors, One Home at a Time
          </h2>
          <p className="text-muted text-base leading-relaxed max-w-2xl mx-auto">
            At Wei Care, we believe every older person deserves to feel valued, respected, and supported in the place they call home. Our carers provide personalised support that encourages safety, independence, and companionship, helping families in Queensland find peace of mind while their loved ones live life to the fullest.
          </p>
        </div>
      </div>

      {/* Image and content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div className="relative">
            <img
              src={empatheticCaregiversImage}
              alt="A carer with an older woman"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl mb-6">
              Our Carers are Empathetic and Caring
            </h3>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-8 max-w-lg">
              <p>
                At Wei Care, we know that hospice care is about far more than physical support: it is about compassion, understanding, and presence. Our carers are trained to bring families peace of mind, easing daily worries so you can focus on what truly matters, spending meaningful time with your loved one. We offer steady guidance and emotional reassurance during life's most sensitive moments, so everyone we support feels valued, cared for, and at ease.
              </p>
              <p className="text-ink font-medium">Our hospice carers can assist with:</p>
            </div>

            <ul className="space-y-5">
              {tasks.map((task) => (
                <li key={task} className="flex items-start gap-4">
                  <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full border border-primary text-primary">
                    <ArrowRight size={16} />
                  </span>
                  <span className="text-ink text-base leading-relaxed">{task}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmpatheticCaregiversSection;
